export const ARRAY_KEY_PREFIX = 'A-';
export const EMPTY_ARRAY_STRING = '-';
export const OBJECT_PLACEHOLDER_KEY = '~place';
// Can't type the result anymore because it now conditional on content of keys
// Arrays will be serialized to object and keys will be prefixed with A-
/*interface SerializedArray<T> {
    Type: '__Array__';
    Data?: Record<string, T>;
}

export type RecursivelySerialized<T> =
    T extends null | undefined ? T :
    T extends Array<infer U> ? SerializedArray<RecursivelySerialized<U>> :
    T extends object ? { [K in keyof (T)]: RecursivelySerialized<T[K]> } : T*/
export function recursivelySerialize(input) {
    return recursivelySerializeArrays(input);
}
export function recursivelySerializeArrays(input) {
    if (typeof (input) !== 'object' || input === null) {
        return input;
    }
    if (Array.isArray(input)) {
        const output = {};
        input.forEach((item, index) => {
            output[addArrayPrefixIfNeeded(index.toString(), item)] = recursivelySerializeArrays(item);
        });
        if (input.length === 0) {
            return EMPTY_ARRAY_STRING;
        }
        return output;
    }
    const output = {};
    let wroteKey = false;
    Object.keys(input).forEach((key) => {
        const rawValue = input[key];
        output[addArrayPrefixIfNeeded(key, rawValue)] = recursivelySerializeArrays(rawValue);
        wroteKey = true;
    });
    if (!wroteKey) {
        output[OBJECT_PLACEHOLDER_KEY] = EMPTY_ARRAY_STRING;
    }
    return output;
}
function addArrayPrefixIfNeeded(key, rawValue) {
    if (Array.isArray(rawValue)) {
        return `${ARRAY_KEY_PREFIX}${key}`;
    }
    return key;
}
// Can't type the result anymore because it now conditional on content of keys
// Keys prefixed with A- will have their values deserialized as arrays
/*export type RecursivelyDeserialized<T> =
    T extends null | undefined ? T :
    T extends SerializedArray<infer U> ? Array<RecursivelyDeserialized<U>> :
    T extends object ? { [k in keyof (T)]: RecursivelyDeserialized<T> } : T*/
export function recursivelyDeserialize(input) {
    return recursivelyDeserializeArrays(input);
}
export function recursivelyDeserializeArrays(input, isSerializedArray = false) {
    if (isSerializedArray && input === EMPTY_ARRAY_STRING) {
        return [];
    }
    if (typeof (input) !== 'object' || input === null) {
        return input;
    }
    if (!isSerializedArray) {
        const output = {};
        for (const key of Object.keys(input)) {
            if (key === OBJECT_PLACEHOLDER_KEY) {
                continue;
            }
            output[removeSerializedArrayPrefix(key)] = recursivelyDeserializeArrays(input[key], isSerializedArrayKey(key));
        }
        return output;
    }
    const output = [];
    Object.keys(input).forEach((key) => {
        output[parseInt(removeSerializedArrayPrefix(key))] = recursivelyDeserializeArrays(input[key], isSerializedArrayKey(key));
    });
    return output;
}
function isSerializedArrayKey(key) {
    return key.startsWith(ARRAY_KEY_PREFIX);
}
function removeSerializedArrayPrefix(key) {
    if (isSerializedArrayKey(key)) {
        return key.substring(ARRAY_KEY_PREFIX.length);
    }
    return key;
}
export function deserializeSnapshot(snapshot) {
    return {
        val: () => recursivelyDeserialize(snapshot.val()),
        child: (path) => deserializeSnapshot(snapshot.child(path)),
        exists: () => snapshot.exists(),
        exportVal: () => recursivelyDeserialize(snapshot.exportVal()),
        hasChild: (path) => snapshot.hasChild(path),
        hasChildren: () => snapshot.hasChildren(),
        key: snapshot.key,
    };
}
//# sourceMappingURL=Serializers.js.map